<script>
import BaseSearchOther from './BaseSearchOther.vue';

export default {
  name: 'question-base-search-vehicle-make',
  extends: BaseSearchOther,
  props: {
    vehicleSystemType: {
      type: String,
      default: null,
    },
  },
  async created () {
    await this.onSearch();
  },
  methods: {
    async onSearch () {
      if (this.optionsConfig?.options) return;

      try {
        const vehicleSystemType = this.constants.VEHICLE_SYSTEM_TYPES[this.vehicleSystemType];

        const response = await this.$api[this.searchType]([vehicleSystemType], this.searchPayload);

        if (response.status === 'success') {
          if (response.data[vehicleSystemType]) {
            this.searchItems = response.data[vehicleSystemType].map(item => ({
              value: item.make_key,
              text: item.make_description,
            }));

            return;
          }

          // Reset the search items or setGroupedOptions will just keep adding to the array
          this.searchItems = [];
          this.setGroupedOptions(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
